import angular from "angular";
import panel from "../services";

function translate (panel) {
    let lang = panel.getLanguage();
    return (input) => {

        return input;
    };
}

export default angular.module('filter.translate', [panel]).filter('translate', translate).name;


// WEBPACK FOOTER //
// ./src/app/filters/iin8.js